
import breakpointMixin from '~/mixins/breakpoints'

export default {
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      anchorHovered: false,
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)
      styles.color = this.blok?.textColorOverride

      return styles
    },
    richtextStyles() {
      const fontSize = this.blok?.textSizeOverride
      const lineHeight = this.blok?.lineHeightOverride
      const maxWidth = this.getBreakpointValue(this.blok.maxWidth)

      return `
          max-width: ${maxWidth};
          font-size: ${fontSize};
          line-height: ${lineHeight};
          cursor: ${this.blok.tooltip?.length && 'help'};
          ${this.blok.styles}
          `
    },
    richTextToHtml() {
      return this.$storyapi.richTextResolver.render(this.blok.richtext)
    },
  },

  mounted() {
    this.$nextTick(() => {
      const anchorTags = this.$refs.richText?.querySelectorAll('a')
      if (anchorTags?.length) {
        anchorTags.forEach((el) => {
          el.addEventListener('mouseenter', () => {
            this.$refs.richText.classList.add('hovered')
          })
          el.addEventListener('mouseleave', () => {
            this.$refs.richText.classList.remove('hovered')
          })
        })
      }
    })
  },
}
